// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

require('./src/themes/prism-okaidia.css');
require('./src/themes/prism-line-numbers.css');